import { getGroupPermissionFactory, PermissionEnum } from '../../../common';
import { getPaymentManagementModuleName } from './payment-management.permissions';

export class PaymentsPermissions {
  static GroupName = `${getPaymentManagementModuleName()}.Payments`;

  static getPermissions = getGroupPermissionFactory(PaymentsPermissions.GroupName);

  static Permissions = {
    Read: PaymentsPermissions.getPermissions(PermissionEnum.READ),
    ReadAll: PaymentsPermissions.getPermissions(PermissionEnum.READ_ALL),
  };
}